import { render, staticRenderFns } from "./MassActiveForm.vue?vue&type=template&id=f475c486"
import script from "./MassActiveForm.vue?vue&type=script&lang=ts"
export * from "./MassActiveForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports